import { useTranslation } from 'react-i18next';
import { StatCard } from '@/shared/ui';
import type { FormattedStats } from '../../lib/types';

interface ServiceStatsProps {
  stats: Partial<FormattedStats> | null;
  isLoading: boolean;
}

export function ServiceStats({ stats, isLoading }: ServiceStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <StatCard
        label={t('report.totreceived.label', 'Total Received')}
        value={stats?.totalReceived || ''}
        variant="success"
        isLoading={isLoading}
      />
      <StatCard
        label={t('report.totreleased.label', 'Total Released')}
        value={stats?.totalReleased || ''}
        variant="info"
        isLoading={isLoading}
      />
      <StatCard
        label={t('report.totpartners.label', 'Service Partners')}
        value={stats?.servicePartners || ''}
        isLoading={isLoading}
      />
    </div>
  );
}
